import { DynamicStandaloneSavedArticles } from '@/components/SavedArticles';
import { LabradorComponent } from '@/types/component';

const LabradorSavedArticles: LabradorComponent = ({ data }) => {
  return (
    <DynamicStandaloneSavedArticles
      headline={data.headline}
      icon={data.icon}
      button={data.button}
      articles={data.articles || []}
      initialArticlesCount={data.initialArticlesCount}
    />
  );
};

export default LabradorSavedArticles;
